<template>
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center justify-content-between">
        <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>
